module.exports = __webpack_public_path__ + "img/1696382580003-NIB ANANDA JELITA.png.8169e703.webp";